import React, { useState } from 'react'

import { Container } from "tabler-react";
const PaginationBar = ({ totalCount, limit = 10, page, setPage }) => {
  const [pagesGroup, setPagesGroup] = useState(0)
  const remainder = (totalCount % limit) || 0
  const noOfPages = remainder ? Math.floor(totalCount / limit) + 1 : (totalCount / limit)

  return (
    totalCount ?
      <Container>
        {totalCount && totalCount > 0 &&
          <div className="page-total-text ">{page === 1 ? 1 : limit * (page - 1)}-{Math.min(page * limit, totalCount)} of {totalCount} items</div>
        }
        {totalCount && totalCount > 0 &&
          <ul className="pagination  pagination-pager">
            <li className={`page-item ${pagesGroup === 0 ? 'disabled' : ''}`}>
              <a className="page-link pointer" tabIndex="-1" href="/" onClick={(e) => {e.preventDefault(); setPagesGroup(p => p - 1)}}>
                Prev
              </a>
            </li>

            {[...Array(Math.min(noOfPages - pagesGroup * 10 < 0 ? 10 : noOfPages - pagesGroup * 10, 10))].map((p, i) =>
              <li className={`page-item pointer ${i + 1 + pagesGroup * 10 === page ? 'active' : ''}`}>
                <a className="page-link" href="/" onClick={(e) => {e.preventDefault(); setPage(i + 1 + pagesGroup * 10)}}><span>{i + 1 + pagesGroup * 10}</span></a>
              </li>
            )}

            <li className={`page-item ${(pagesGroup + 1) * 10 >= noOfPages ? 'disabled' : ''}`}>
              <a className="page-link" href="/" onClick={(e) => {e.preventDefault(); setPagesGroup(p => p + 1)}}>
                Next
              </a>
            </li>
          </ul>
        }
      </Container> : null
  );
}

export default PaginationBar;